import { Link } from "react-router-dom";
import { PageHero } from "../components/ui-kit";
import { Reveal } from "../motion";
import { OFFICE, PARTNERS_CONTACT } from "../content";

const BLOCKS = [
  { h: "Identificação do escritório", p: "Pahl & Burgueño Advogados é sociedade de advogados registrada na OAB/RS sob o nº 16.129, inscrita no CNPJ sob o nº 59.271.936/0001-08. Sócios-fundadores: Lucas Pahl Schaan Núñez, OAB/RS 88.998, e Rodrigo Menezes Burgueño, OAB/RS 141.361." },
  { h: "Natureza informativa do conteúdo", p: "As informações disponibilizadas neste site possuem caráter geral e informativo. Elas não constituem parecer jurídico, orientação aplicável a caso concreto ou promessa de resultado. A solução de uma questão jurídica depende da análise de fatos, documentos, prazos, legislação e demais circunstâncias específicas." },
  { h: "Contato e contratação", p: "O envio de mensagem por e-mail, WhatsApp ou outro canal não constitui automaticamente relação advogado-cliente e não implica aceitação do assunto pelo escritório. A prestação de serviços somente terá início após análise de disponibilidade e conflitos, definição do escopo e formalização da contratação." },
  { h: "Envio de informações e documentos", p: "Antes da confirmação de atendimento, não encaminhe informações confidenciais, documentos sigilosos ou dados pessoais sensíveis. Em situações sujeitas a prazo, a mensagem inicial não substitui a adoção tempestiva das providências necessárias." },
  { h: "Dados encaminhados pelos canais de contato", p: "Os dados enviados pelos canais oficiais poderão ser utilizados para responder à mensagem, realizar verificações preliminares de atendimento e cumprir obrigações legais e profissionais aplicáveis. Os canais externos utilizados, como e-mail, WhatsApp e LinkedIn, estão sujeitos também às regras e políticas das respectivas plataformas." },
  { h: "Direitos autorais", p: "Os textos, elementos gráficos e demais conteúdos próprios deste site são protegidos pela legislação aplicável. A reprodução ou utilização além dos limites legais depende de autorização prévia." },
];

export default function InfoLegais() {
  return (
    <>
      <PageHero eyebrow="Informações legais" titleLines={["Informações legais", "e institucionais."]} />
      <section className="bg-bone py-20 lg:py-28">
        <div className="mx-auto max-w-[900px] px-6 lg:px-10 space-y-12">
          {BLOCKS.map((b, i) => (
            <Reveal key={i} className="border-t border-ink/12 pt-8">
              <h2 className="serif text-2xl lg:text-3xl text-ink mb-4">{b.h}</h2>
              <p className="text-ink/70 text-lg leading-relaxed font-light">{b.p}</p>
            </Reveal>
          ))}
          <Reveal className="bg-ink text-bone rounded-2xl p-8 grain overflow-hidden">
            <div className="eyebrow text-gold mb-4">Canais oficiais</div>
            <div className="space-y-1.5 text-bone/75 text-sm">
              <div>E-mail: {OFFICE.email}</div>
              <div>Site: {OFFICE.site}</div>
              <div>Lucas: {PARTNERS_CONTACT.lucas.phone} · Rodrigo: {PARTNERS_CONTACT.rodrigo.phone}</div>
              <div className="pt-3 text-bone/50">{OFFICE.society} · {OFFICE.cnpj} · {OFFICE.city}</div>
            </div>
            <Link to="/contato" data-testid="info-cta" className="btn-gold mt-7">Entre em contato</Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
